function QuoteNoContent() {
  return (
    <p>
      <span className="text-brand-text">$&nbsp;</span>No quote available.
    </p>
  );
}

export default QuoteNoContent;
